"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textValueFormula = exports.DocPageSnapshotSchema = exports.DocNodeModelSchema = exports.SlotDocNodeSchema = exports.ElementDocNodeSchema = exports.TextDocNodeSchema = exports.CustomPropertyMapSchema = exports.CustomPropertySchema = exports.CustomPropertyNameSchema = exports.CssPropertySyntaxSchema = exports.CssSyntaxNodeSchema = exports.CSS_PROPERTY_SYNTAXES = exports.CSS_PRIMITIVE_SYNTAXES = void 0;
const zod_1 = require("zod");
const formula_1 = require("./formula");
exports.CSS_PRIMITIVE_SYNTAXES = [
    '*',
    'color',
    'length',
    'number',
    'percentage',
    'integer',
    'string',
];
exports.CSS_PROPERTY_SYNTAXES = [
    '*',
    '<color>',
    '<length>',
    '<number>',
];
exports.CssSyntaxNodeSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal('primitive'),
        name: zod_1.z.enum(exports.CSS_PRIMITIVE_SYNTAXES),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('keyword'),
        keywords: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    }),
]);
exports.CssPropertySyntaxSchema = zod_1.z.union([
    zod_1.z.enum(exports.CSS_PROPERTY_SYNTAXES),
    exports.CssSyntaxNodeSchema,
]);
exports.CustomPropertyNameSchema = zod_1.z
    .string()
    .regex(/^--[a-zA-Z0-9-_]+$/, 'custom property must be a CSS --token name');
exports.CustomPropertySchema = zod_1.z.object({
    formula: formula_1.FormulaSchema,
    unit: zod_1.z.string().min(1).nullable().optional(),
    syntax: exports.CssPropertySyntaxSchema.nullable().optional(),
});
exports.CustomPropertyMapSchema = zod_1.z.record(exports.CustomPropertyNameSchema, exports.CustomPropertySchema);
const NodeSharedSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    slot: zod_1.z.string().nullable().optional(),
    slotIndex: zod_1.z.number().int().min(0).nullable().optional(),
    condition: formula_1.FormulaSchema.nullable().optional(),
    repeat: formula_1.FormulaSchema.nullable().optional(),
    repeatKey: formula_1.FormulaSchema.nullable().optional(),
    customProperties: zod_1.z
        .record(exports.CustomPropertyNameSchema, exports.CustomPropertySchema)
        .nullable()
        .optional(),
});
exports.TextDocNodeSchema = NodeSharedSchema.extend({
    type: zod_1.z.literal('text'),
    value: formula_1.FormulaSchema,
});
exports.ElementDocNodeSchema = NodeSharedSchema.extend({
    type: zod_1.z.literal('element'),
    flavour: zod_1.z.string().min(1),
    tag: zod_1.z.string().min(1),
    attrs: zod_1.z.record(zod_1.z.string(), formula_1.FormulaSchema).default({}),
    style: zod_1.z.record(zod_1.z.string(), zod_1.z.union([zod_1.z.string(), zod_1.z.number()])).optional(),
    children: zod_1.z.array(zod_1.z.string().min(1)),
});
exports.SlotDocNodeSchema = NodeSharedSchema.omit({
    repeat: true,
    repeatKey: true,
}).extend({
    type: zod_1.z.literal('slot'),
    name: zod_1.z.string().nullable().optional(),
    children: zod_1.z.array(zod_1.z.string().min(1)),
});
exports.DocNodeModelSchema = zod_1.z.discriminatedUnion('type', [
    exports.TextDocNodeSchema,
    exports.ElementDocNodeSchema,
    exports.SlotDocNodeSchema,
]);
exports.DocPageSnapshotSchema = zod_1.z.object({
    snapshotVersion: zod_1.z.literal(1),
    contentType: zod_1.z.literal('doc_page'),
    workspaceId: zod_1.z.string().min(1),
    docId: zod_1.z.string().min(1),
    rootNodeId: zod_1.z.string().min(1),
    title: zod_1.z.string(),
    materializedAt: zod_1.z.string().datetime(),
    nodes: zod_1.z.record(zod_1.z.string().min(1), exports.DocNodeModelSchema),
});
const textValueFormula = (value) => ({
    type: 'value',
    value,
});
exports.textValueFormula = textValueFormula;
